import createModule from "../createModule"
import view from "./view"
import { Creators } from "model/hookUpdater"
import { Creators as notificationsCreators } from "modules/notifications/model"

export default createModule({
  view,
  externalProps: (state) => ({
    account: state.global.selected.account,
  }),
  required: ["account"],
  data: [{
    resource: "sessionSettings",
    url: ({ account }) => `/api/${account}/sessions`,
  }],
  actions: {
    ...notificationsCreators,
    ...Creators,
  },
})
